export const SITE_KEYS = {
  qa: '6LcBtZ4aAAAAAKVsYvH1tWU45rKWhjcIHwOSIlO5',
  prod: '6LdotZ4aAAAAAAn1dUFF5SqGpgU16Mn4W0etd4-X'
};
export const V3_SITE_KEYS = {
  qa: '6LeAe9UfAAAAAEmg7cdYdCkl1RyUsWGjCBE7zc69',
  prod: '6LetHNsfAAAAAJ4d-05yPjpAPhzl3MwFp98PwMIu'
};